/* ============================================================================== */
/*                    Database file with routing information                      */
/* ============================================================================== */

/*
  -- The IDs of the items are sequential just for uniqueness purposes, in fact the string represents a name, NOT an ordered succession, as order may vary depending on the customer's requirements.
  -- The only naming convetion applied is q - question, r - result.
  -- IDs in checkboxes are needed for routing combination logic (see scripts/scripts.js),
  -------
*/

var questions = [
   {
      id: "q-1",
      question: "Is there a strong rationale for randomizing groups rather than individuals to study conditions?",
      top_text:
         "",
      note_text:
         "<div>There may be logistical reasons to randomize groups or clusters to study arms or it may not be possible to deliver the intervention to individuals in the same group or cluster without substantial risk of contamination.</div>",
      type: "radio",
      options: [
         {
            id: 1,
            text: "Yes",
            target: "q-2a",
         },
         {
            id: 2,
            text: "No",
            target: "q-2b",
         },
      ],
   },
   {
      id: "q-2a",
      question: "Is there a strong rationale for rolling out the intervention to all groups or clusters before the trial is over?",
      top_text:
         "",
      note_text:
         "<div>There may be political or logistical reasons to roll out the intervention to all groups or clusters before the trial is over.</div>",
      type: "radio",
      options: [
         {
            id: 1,
            text: "Yes",
            target: "r-1",
         },
         {
            id: 2,
            text: "No",
            target: "r-2",
         },
      ],
      bottom_text:
         "",
   },
   {
      id: "q-2b",
      question: "Do participants receive any of their treatment in a group format or from a shared intervention agent?",
      top_text:
         "",
      note_text:
         "<div>If any of the intervention is delivered through physical or virtual groups, or through shared intervention agents who each work with multiple participants, positive intraclass correlation can develop over the course of the trial.</div>",
      type: "radio",
      options: [
         {
            id: 1,
            text: "Yes",
            target: "r-3",
         },
         {
            id: 2,
            text: "No",
            target: "r-4",
         },
      ],
      bottom_text:
         "",
   },
];

var answers = [
   {
      id: "r-1",
      text:
         "<p>You have indicated that there is a strong rationale for randomizing groups or clusters rather than individuals to study arms. You have also indicated that there is a strong rationale for rolling out the intervention to all groups or clusters before the end of the trial. The appropriate study design for this situation is a Group- or Cluster-Randomized Stepped Wedge Design. For more information on this design and a sample size calculator to help you plan your trial, please visit the Stepped Wedge Group-Randomized Trials page of the NIH Research Methods Resources website at <a href=\"https://researchmethodsresources.nih.gov/methods/SWGRT\" target=\"_blank\">https://researchmethodsresources.nih.gov/methods/SWGRT</a>.</p>",
   },
   {
      id: "r-2",
      text:
         "<p>You have indicated that there is a strong rationale for randomizing groups or clusters rather than individuals to study arms. You have also indicated that there is not a strong rationale for rolling out the intervention to all groups or clusters before the end of the trial. The appropriate study design for this situation is a Parallel Group- or Cluster-Randomized Design. For more information on this design and a sample size calculator to help you plan your trial, please visit the Parallel Group-Randomized Trials page of the NIH Research Methods Resources website at <a href=\"https://researchmethodsresources.nih.gov/methods/grt\" target=\"_blank\">https://researchmethodsresources.nih.gov/methods/grt</a>.</p>",
   },   
   {
      id: "r-3",
      text:
         "<p>You have indicated that there is not a strong rationale for randomizing groups or clusters rather than individuals to study arms. You have also indicated that participants will receive at least part of their treatment in a group format or from a shared intervention agent. The appropriate study design for this situation is an Individually Randomized Group Treatment Trial Design. For more information on this design and a sample size calculator to help you plan your trial, please visit the Individually Randomized Group-Treatment Trials page of the NIH Research Methods Resources website at <a href=\"https://researchmethodsresources.nih.gov/methods/irgt\" target=\"_blank\">https://researchmethodsresources.nih.gov/methods/irgt</a>.</p>",
   },
   {
      id: "r-4",
      text:
         "<p>You have indicated that there is not a strong rationale for randomizing groups or clusters rather than individuals to study arms. You have also indicated that participants will not receive any part of their treatment in a group format or from a shared intervention agent. The appropriate study design for this situation is a Randomized Controlled Trial. Information and resources for RCTs are readily available from standard textbooks and clinical trial websites. For more information on broadly applicable methods that often pertain to randomized controlled trials, please visit the Broadly Applicable Methods page of the NIH Research Methods Resources website at <a href=\"https://researchmethodsresources.nih.gov/methods/additional\" target=\"_blank\">https://researchmethodsresources.nih.gov/methods/additional</a>.</p>",
   },

];

export { questions, answers };
